import React, { useEffect, useState } from 'react'
import Footer from '@/components/Footer'
import Logo from '@/assets/logo.svg'
import LoginForm from './form'
import LoginBanner from './banner'
import styles from '@/style/index.module.less'
import WxPhone from './wxPhone'
import Modal from '@/components/Modal'
import { useHistory } from 'react-router-dom'
function Login() {
  const history = useHistory()
  const [isWx, setIsWx] = useState(false)
  useEffect(() => {
    if (navigator.userAgent.includes('miniProgram')) {
      // 在微信小程序环境中
      setIsWx(true)
    } else {
      // 不在微信小程序环境中
      setIsWx(false)
    }
  }, [])

  useEffect(() => {
    document.title = '登录 - 京网智云'
  }, [])
  return (
    <>
      {!isWx ? (
        <div className={styles.container}>
          <div className={styles.logo}>
            <Logo
              onClick={() => {
                history.push('/home')
              }}
            />
          </div>
          <div className={styles.content}>
            <div className={styles['content-inner']}>
              <div className={styles.cc}>
                <LoginForm />
              </div>
            </div>
            <div className={styles.footer}>
              <Footer />
            </div>
          </div>
          <div></div>
          {/* <ALIYUN></ALIYUN> */}
          <div className={styles.banner}>
            <div className={styles['banner-inner']}>
              <LoginBanner />
            </div>
          </div>
          <Modal></Modal>
        </div>
      ) : (
        <WxPhone></WxPhone>
      )}
    </>
  )
}
Login.displayName = 'LoginPage'

export default Login
